import { styled } from '@mui/material/styles';
import { layoutVerticalGapStyles } from '../../sharedStyles/layoutStyles';

export const StyledSection = styled('section')(
  ({ theme }) => `
    position: relative;
 
    width: 100%;
    ${layoutVerticalGapStyles({ theme })};
    color: ${theme.DS_palette.primary.black};
  `,
);
